module.exports = __webpack_public_path__ + "assets/img/fd712e0412216bf15b2dd8d723cda4cc.png";